import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-logged-layout',
  templateUrl: './logged-layout.component.html',
  styleUrls: ['./logged-layout.component.scss']
})
export class LoggedLayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
